import { render } from "./OnlineDonation.vue?vue&type=template&id=1157a8be&scoped=true"
import script from "./OnlineDonation.vue?vue&type=script&lang=js"
export * from "./OnlineDonation.vue?vue&type=script&lang=js"

import "./OnlineDonation.vue?vue&type=style&index=0&id=1157a8be&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1157a8be"]])

export default __exports__